<template>
    <div class="min-h-screen bg-background">
        <welcome-navbar />
        <main>
            <welcome-hero />
            <welcome-tofas-trust />
            <welcome-quick-courses :courses="courses" :loading="loading" />
            <welcome-grade-picker />
            <welcome-about />
            <welcome-learning-system />
            <welcome-tools-ecosystem />
            <welcome-follow-daily />
            <WelcomeFinalCTA />
        </main>
        <welcome-footer />
    </div>
</template>

<script>
import WelcomeNavbar from './WelcomeNavbar.vue';
import WelcomeHero from './WelcomeHero.vue';
import WelcomeTofasTrust from './WelcomeTofasTrust.vue';
import WelcomeQuickCourses from './WelcomeQuickCourses.vue';
import WelcomeGradePicker from './WelcomeGradePicker.vue';
import WelcomeAbout from './WelcomeAbout.vue';
import WelcomeLearningSystem from './WelcomeLearningSystem.vue';
import WelcomeToolsEcosystem from './WelcomeToolsEcosystem.vue';
import WelcomeFollowDaily from './WelcomeFollowDaily.vue';
import WelcomeFinalCTA from './WelcomeFinalCTA.vue';
import WelcomeFooter from './WelcomeFooter.vue';

export default {
    name: 'WelcomeLanding',
    components: {
        WelcomeNavbar,
        WelcomeHero,
        WelcomeTofasTrust,
        WelcomeQuickCourses,
        WelcomeGradePicker,
        'welcome-grade-picker': WelcomeGradePicker,
        WelcomeAbout,
        WelcomeLearningSystem,
        WelcomeToolsEcosystem,
        WelcomeFollowDaily,
        WelcomeFinalCTA,
        WelcomeFooter,
    },
    props: {
        courses: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
